import { atom } from "recoil";

export const StatusTrangthaiState = atom({
  key: "StatusTrangthaiState",
  default: undefined,
});
